import type { Func } from '@ricoh/ria.client.core/types/core/function.type';

import qs from 'qs';

import type { ServiceServerServiceConfigBase } from './_config.type';

import { ServiceServerError } from './_error';

/** Create ServiceServer Service Config Base options. */
export const createServiceServerServiceConfigBase = {
  options:
    (headers: Record<string, string> = {}): Func<[keyBase: string], ServiceServerServiceConfigBase['options']> =>
    (keyBase: string) => ({
      baseURL: keyBase,
      withCredentials: true,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        ...headers,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, {
          arrayFormat: 'comma',
        }),
    }),

  createError:
    <TName extends string>() =>
    <TModule extends string, TEndpoints extends Record<string, unknown>>(
      module: `${TName}.${TModule}`,
    ): ServiceServerServiceConfigBase<TName, TModule, TEndpoints>['createError'] =>
    (endpoint, message, exception, prepareError) =>
      ServiceServerError.create(
        {
          status: 500,
          endpoint: `${module}.${endpoint.toString()}`,
          message,
          cause: exception,
        },
        prepareError,
      ),
};
